"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Header = _interopRequireDefault(require("./Header"));

var _Loader = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Loader"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _editor = _interopRequireDefault(require("@insided/deprecated-preact-components/editor"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Attachments = _interopRequireDefault(require("@insided/deprecated-control/category/Attachments"));

var _datePicker = _interopRequireDefault(require("@insided/deprecated-preact-components/date-picker"));

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _DropdownBox = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/DropdownBox"));

var _AccordionPanel = _interopRequireDefault(require("@insided/deprecated-control/panel/AccordionPanel"));

var _PanelHeaderWithIcon = require("@insided/deprecated-control/ui-components/PanelHeaderWithIcon");

var _FeaturedTopicsManager = _interopRequireDefault(require("@insided/destination/modules/Navigation/widget-featured-topics/FeaturedTopicsManager"));

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _EventDateFormatter = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDateFormatter"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _TimezoneSelector = _interopRequireDefault(require("@insided/control/uikit/TimezoneSelector"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _TimepickerV = _interopRequireDefault(require("@insided/deprecated-preact-components/timepicker/TimepickerV2"));

var _common = require("@insided/shared/utils/common");

var _validation = require("@insided/shared/utils/validation");

var _common2 = require("@insided/deprecated-control/Event/create-event/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DEFAULT_START_TIME = {
  hours: '12',
  minutes: '00',
  period: 'AM'
};

var prepareEventState = function prepareEventState(event) {
  var _event$status;

  return _objectSpread(_objectSpread({}, event), {}, {
    startTime: event.startDate ? event.startTime : {},
    endTime: event.endDate ? event.endTime : {},
    featuredTopics: event.featuredTopics,
    externalRegistrationUrl: event.externalRegistrationUrl,
    enableRsvpGroupPicker: event.externalRegistrationUrl ? 'external' : 'community',
    isEventPassed: _EventDateFormatter.default.isEventPassed(event.endDate, event.endTime, event.timezone),
    status: (_event$status = event.status) !== null && _event$status !== void 0 ? _event$status : 'published'
  });
};

var isTimeValid = function isTimeValid(time) {
  return !!(time.minutes && time.hours && time.period);
};

var getFullDateString = function getFullDateString(date, time) {
  var _date$split = date.split('-'),
      _date$split2 = (0, _slicedToArray2.default)(_date$split, 3),
      year = _date$split2[0],
      month = _date$split2[1],
      day = _date$split2[2];

  var fullDateString = "".concat(year, "-").concat(month.length > 1 ? month : "0".concat(month), "-").concat(day.length > 1 ? day : "0".concat(day));

  var fullTime24hour = _EventDateFormatter.default.convert12hourTo24hour(time);

  return "".concat(fullDateString, "T").concat(fullTime24hour);
};

var getDateString = function getDateString(date) {
  return date ? "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate()) : '';
};

var getTimeString = function getTimeString(time) {
  return time !== null && time !== void 0 && time.hours ? "".concat(time.hours, ":").concat(time.minutes, " ").concat(time.period) : '';
};

var getSameDateEndTimeHours = function getSameDateEndTimeHours(date) {
  var endDateTimeObj = new Date(date.getTime() + 60 * 60 * 1000);

  var _EventDateFormatter$g = _EventDateFormatter.default.getTimeWithPeriod(endDateTimeObj),
      endTimeHours = _EventDateFormatter$g.hours;

  return endTimeHours !== null && endTimeHours !== void 0 ? endTimeHours : '';
};

var EventCreator = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventCreator, _Component);

  var _super = _createSuper(EventCreator);

  function EventCreator(props) {
    var _event$userGroupId, _props$groups;

    var _this;

    (0, _classCallCheck2.default)(this, EventCreator);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "csrfToken", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isPrivateGroupEnabled", _common.common.isModuleActive('privateGroup'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUnload", function (e) {
      var hasUnsavedChanges = _this.state.hasUnsavedChanges;

      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onStartDateChange", function (dates) {
      if (!dates.length) return;
      var _this$state = _this.state,
          errors = _this$state.errors,
          startTime = _this$state.startTime,
          endDate = _this$state.endDate,
          endTime = _this$state.endTime;
      var startTimeObj = startTime !== null && startTime !== void 0 && startTime.hours ? _objectSpread({}, startTime) : _objectSpread({}, DEFAULT_START_TIME);
      var startDateString = getDateString(dates[0]);
      var updateStateObj = {
        startDate: startDateString,
        startTime: startTimeObj,
        hasUnsavedChanges: true,
        errors: errors.clearError('startDate').clearError('startTime')
      };
      var noEndDateTimeSet = !endDate && !isTimeValid(endTime);
      var endDateObj = !noEndDateTimeSet && new Date(getFullDateString(endDate, endTime));
      var isStartDateEarlierEndDate = endDateObj && startDateString !== _this.state.endDate && dates[0] < endDateObj;

      if (noEndDateTimeSet || !isStartDateEarlierEndDate) {
        var utcDate = getFullDateString(startDateString, startTimeObj);
        var startDateObj = new Date(utcDate);

        _this.setState(_objectSpread(_objectSpread({}, updateStateObj), {}, {
          setEndDateManually: true,
          endDate: startDateString,
          endTime: _objectSpread(_objectSpread({}, startTimeObj), {}, {
            hours: getSameDateEndTimeHours(startDateObj)
          }),
          errors: errors.clearError('endDate').clearError('endTime')
        }));
      } else {
        _this.setState(updateStateObj);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEndDateChange", function (dates) {
      if (!dates.length) return;
      var _this$state2 = _this.state,
          errors = _this$state2.errors,
          startDate = _this$state2.startDate,
          startTime = _this$state2.startTime,
          endTime = _this$state2.endTime;
      var endDateString = getDateString(dates[0]);
      var updateStateObj = {
        setEndDateManually: false,
        endDate: endDateString,
        errors: errors.clearError('endDate').clearError('endTime'),
        hasUnsavedChanges: true
      };
      var startDateObj = startDate && isTimeValid(startTime) && new Date(getFullDateString(startDate, startTime));
      var endDateObj = endDateString && isTimeValid(endTime) && new Date(getFullDateString(endDateString, endTime));
      var isEndDateEarlierStartDate = startDateObj && endDateObj && endDateObj < startDateObj;

      if (isEndDateEarlierStartDate) {
        _this.setState(_objectSpread(_objectSpread({}, updateStateObj), {}, {
          setEndDateManually: true,
          endDate: startDate,
          endTime: _objectSpread(_objectSpread({}, startTime), {}, {
            hours: getSameDateEndTimeHours(startDateObj)
          }),
          errors: errors.clearError('endDate').clearError('endTime')
        }));
      } else {
        _this.setState(updateStateObj);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseStartTimepicker", function (dates) {
      if (dates) {
        var timeByParts = _EventDateFormatter.default.getTimeWithPeriod(dates[0]);

        var errors = _this.state.errors;
        var updateStateObj = {
          startTime: _objectSpread({}, timeByParts),
          errors: errors.clearError('startTime'),
          hasUnsavedChanges: true
        };
        var endDateObj = new Date(getFullDateString(_this.state.endDate, _this.state.endTime));

        if (_this.state.startDate !== _this.state.endDate || dates[0] < endDateObj) {
          _this.setState(updateStateObj);
        } else {
          _this.setState(_objectSpread(_objectSpread({}, updateStateObj), {}, {
            endTime: _objectSpread(_objectSpread({}, timeByParts), {}, {
              hours: getSameDateEndTimeHours(dates[0])
            }),
            errors: errors.clearError('endTime')
          }));
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCloseEndTimepicker", function (dates) {
      if (dates) {
        var timeByParts = _EventDateFormatter.default.getTimeWithPeriod(dates[0]);

        var errors = _this.state.errors;
        var updateStateObj = {
          endTime: _objectSpread({}, timeByParts),
          errors: errors.clearError('endTime'),
          hasUnsavedChanges: true
        };
        var startDateObj = new Date(getFullDateString(_this.state.startDate, _this.state.startTime));

        if (_this.state.startDate !== _this.state.endDate || startDateObj < dates[0]) {
          _this.setState(updateStateObj);
        } else {
          _this.setState(_objectSpread(_objectSpread({}, updateStateObj), {}, {
            endTime: _objectSpread(_objectSpread({}, timeByParts), {}, {
              hours: getSameDateEndTimeHours(startDateObj)
            }),
            errors: errors.clearError('endTime')
          }));
        }
      }
    });
    var event = props.event ? prepareEventState(props.event) : (0, _common2.getDefaultEventState)(props.timezoneList);
    var defaultState = (0, _common2.getDefaultConstructorState)((_event$userGroupId = event.userGroupId) !== null && _event$userGroupId !== void 0 ? _event$userGroupId : 0, (_props$groups = props.groups) !== null && _props$groups !== void 0 ? _props$groups : []); // eslint-disable-next-line react/state-in-constructor

    _this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
      enableGroupsPicker: !!event.userGroupId && event.status !== 'published',
      enableRsvpGroupPicker: null,
      isVisibilityPanelClicked: false,
      isEventPassed: false,
      setEndDateManually: false,
      startDateFP: null,
      endDateFP: null
    }, event);
    _this.csrfToken = props.csrfToken;
    return _this;
  }

  (0, _createClass2.default)(EventCreator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
          _this$state$featuredI;

      window.addEventListener('beforeunload', function (e) {
        return _this2.onUnload(e);
      });
      document.body.classList.add(this.state.status);
      this.setImageDimensions((_this$state$featuredI = this.state.featuredImage) !== null && _this$state$featuredI !== void 0 ? _this$state$featuredI : '');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "setImageDimensions",
    value: function setImageDimensions(imgSrc) {
      var _this3 = this;

      var img = new Image();

      img.onload = function () {
        _this3.setState({
          featuredImageDimensions: {
            width: img.naturalWidth,
            height: img.naturalHeight
          }
        });
      };

      img.src = imgSrc;
    }
  }, {
    key: "handlePostErrors",
    value: function handlePostErrors(responseError) {
      if (responseError) {
        var errors = responseError.data.errors;
        var errorsText = errors ? errors.join('\n') : 'Something went wrong';
        this.setState({
          backendResponse: {
            messageType: 'error',
            messageText: errorsText
          }
        });
      }
    }
  }, {
    key: "hasErrors",
    value: function hasErrors() {
      var errors = this.state.errors;
      errors.clear();
      this.validateTitle();
      this.validateRequiredFields();
      this.validateOptionalFields();
      return !this.state.errors.isEmpty();
    }
  }, {
    key: "hasDraftErrors",
    value: function hasDraftErrors() {
      var errors = this.state.errors;
      errors.clear();
      this.validateTitle();
      this.validateDraftRequiredFields();
      this.validateOptionalFields();
      return !this.state.errors.isEmpty();
    }
  }, {
    key: "validateRequiredFields",
    value: function validateRequiredFields() {
      var _this$state3 = this.state,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate,
          startTime = _this$state3.startTime,
          endTime = _this$state3.endTime,
          errors = _this$state3.errors,
          timezone = _this$state3.timezone,
          description = _this$state3.description,
          externalRegistrationUrl = _this$state3.externalRegistrationUrl,
          externalRegistrationUrlLabel = _this$state3.externalRegistrationUrlLabel,
          enableRsvpGroupPicker = _this$state3.enableRsvpGroupPicker;
      var fieldsErrors;

      if (!startDate) {
        fieldsErrors = errors.addError('startDate', _common2.errorMessages.startDateEmpty);
      }

      if (!endDate) {
        fieldsErrors = errors.addError('endDate', _common2.errorMessages.endDateEmpty);
      }

      if (!timezone.value) {
        fieldsErrors = errors.addError('timezone', _common2.errorMessages.timezoneEmpty);
      }

      if (!startTime.minutes || !startTime.hours || !startTime.period) {
        fieldsErrors = errors.addError('startTime', _common2.errorMessages.startTimeEmpty);
      }

      if (!endTime.minutes || !endTime.hours || !endTime.period) {
        fieldsErrors = errors.addError('endTime', _common2.errorMessages.endTimeEmpty);
      }

      if (startDate && isTimeValid(startTime) && endDate && isTimeValid(endTime) && new Date(getFullDateString(startDate, startTime)) > new Date(getFullDateString(endDate, endTime))) {
        fieldsErrors = errors.addError('endDate', _common2.errorMessages.endDateBeforeStartDate).addError('endTime', ' ');
      }

      if (description.replace(/(<([^>]+)>)|(&[a-zA-Z]*;)|(\r\n|\n|\r)/gim, '').length < 3) {
        fieldsErrors = errors.addError('description', _common2.errorMessages.descriptionTooShort);
      }

      if (!enableRsvpGroupPicker) {
        fieldsErrors = errors.addError('registration', _common2.errorMessages.registration);
      }

      if (enableRsvpGroupPicker === 'external' && !externalRegistrationUrl) {
        fieldsErrors = errors.addError('externalRegistrationUrl', _common2.errorMessages.externalRegistrationUrlEmpty);
      }

      if (enableRsvpGroupPicker === 'external' && !externalRegistrationUrlLabel) {
        fieldsErrors = errors.addError('externalRegistrationUrlLabel', _common2.errorMessages.externalRegistrationUrlLabelEmpty);
      }

      if (enableRsvpGroupPicker === 'external' && !!externalRegistrationUrl && !!externalRegistrationUrlLabel && !(0, _common2.isValidUrl)(externalRegistrationUrl)) {
        fieldsErrors = errors.addError('externalRegistrationUrl', _common2.errorMessages.externalRegistrationUrlNotValid);
      }

      if (fieldsErrors) {
        this.setState({
          errors: fieldsErrors
        });
      }
    }
  }, {
    key: "validateOptionalFields",
    value: function validateOptionalFields() {
      var _this$state4 = this.state,
          errors = _this$state4.errors,
          url = _this$state4.url,
          urlLabel = _this$state4.urlLabel;
      var fieldsErrors;

      if (!!url && !urlLabel) {
        fieldsErrors = errors.addError('urlLabel', _common2.errorMessages.urlTextEmpty);
      }

      if (!!urlLabel && !url) {
        fieldsErrors = errors.addError('url', _common2.errorMessages.urlLinkEmpty);
      }

      if (!!urlLabel && !!url && !(0, _common2.isValidUrl)(url)) {
        fieldsErrors = errors.addError('url', _common2.errorMessages.urlLinkNotValid);
      }

      if (fieldsErrors) {
        this.setState({
          errors: fieldsErrors
        });
      }
    }
  }, {
    key: "validateDraftRequiredFields",
    value: function validateDraftRequiredFields() {
      var _this$state5 = this.state,
          errors = _this$state5.errors,
          description = _this$state5.description,
          enableRsvpGroupPicker = _this$state5.enableRsvpGroupPicker,
          externalRegistrationUrl = _this$state5.externalRegistrationUrl,
          externalRegistrationUrlLabel = _this$state5.externalRegistrationUrlLabel,
          startDate = _this$state5.startDate,
          endDate = _this$state5.endDate,
          timezone = _this$state5.timezone;
      var fieldsErrors;

      if (description.replace(/(<([^>]+)>)|(&[a-zA-Z]*;)|(\r\n|\n|\r)/gim, '').length < 3) {
        fieldsErrors = errors.addError('description', _common2.errorMessages.descriptionTooShort);
      }

      if (enableRsvpGroupPicker === 'external' && !externalRegistrationUrl) {
        fieldsErrors = errors.addError('externalRegistrationUrl', _common2.errorMessages.externalRegistrationUrlEmpty);
      }

      if (enableRsvpGroupPicker === 'external' && !externalRegistrationUrlLabel) {
        fieldsErrors = errors.addError('externalRegistrationUrlLabel', _common2.errorMessages.externalRegistrationUrlLabelEmpty);
      }

      if (enableRsvpGroupPicker === 'external' && !!externalRegistrationUrl && !!externalRegistrationUrlLabel && !(0, _common2.isValidUrl)(externalRegistrationUrl)) {
        fieldsErrors = errors.addError('externalRegistrationUrl', _common2.errorMessages.externalRegistrationUrlNotValid);
      }

      if (startDate && endDate && !timezone.value) {
        fieldsErrors = errors.addError('timezone', _common2.errorMessages.timezoneEmpty);
      }

      if (fieldsErrors) {
        this.setState({
          errors: fieldsErrors
        });
      }
    }
  }, {
    key: "validateTitle",
    value: function validateTitle() {
      var _this$state6 = this.state,
          title = _this$state6.title,
          errors = _this$state6.errors;
      var fieldsErrors;

      if (!title) {
        fieldsErrors = errors.addError('title', _common2.errorMessages.titleEmpty);
      } else if (title.length < _validation.MIN_TITLE_LENGTH) {
        fieldsErrors = errors.addError('title', _common2.errorMessages.titleTooShort);
      }

      if (fieldsErrors) {
        this.setState({
          errors: fieldsErrors
        });
      }
    }
  }, {
    key: "hasTiming",
    value: function hasTiming() {
      var _this$state7 = this.state,
          timezone = _this$state7.timezone,
          startDate = _this$state7.startDate,
          endDate = _this$state7.endDate,
          startTime = _this$state7.startTime,
          endTime = _this$state7.endTime,
          errors = _this$state7.errors;
      var isTimingSet = !!(timezone !== null && timezone !== void 0 && timezone.value && startDate && endDate && isTimeValid(startTime) && isTimeValid(endTime));
      var hasTimingErrors = errors.containsOneOf(['timezone', 'startTime', 'endTime', 'startDate', 'endDate']);
      return isTimingSet && !hasTimingErrors;
    }
  }, {
    key: "hasDescription",
    value: function hasDescription() {
      var description = this.state.description;
      return description.replace(/(<([^>]+)>)|(&.+;)|(\r\n|\n|\r)/gim, '').length >= 3;
    }
  }, {
    key: "showValidationError",
    value: function showValidationError() {
      this.setState({
        backendResponse: {
          messageType: 'error',
          messageText: 'Some fields are missing'
        }
      });
    }
  }, {
    key: "onPublish",
    value: function () {
      var _onPublish = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this$state8, status, eventId, endDate, timezone, startDate, endpoint, data, res, isSaveErrorResponse, isErrorResponse, responseError;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$state8 = this.state, status = _this$state8.status, eventId = _this$state8.eventId, endDate = _this$state8.endDate, timezone = _this$state8.timezone, startDate = _this$state8.startDate;

                if (!(this.hasErrors() || !startDate || !endDate || !timezone.value)) {
                  _context.next = 4;
                  break;
                }

                this.showValidationError();
                return _context.abrupt("return");

              case 4:
                this.setState({
                  isLoading: true
                });
                _axios.default.defaults.headers.common = {
                  'X-CSRF-TOKEN': this.csrfToken
                };
                endpoint = status === 'draft' ? "/event/".concat(eventId, "/publish") : '/content/publish/event';
                data = _objectSpread(_objectSpread({}, (0, _common2.getPublishData)(this.state)), {}, {
                  status: ''
                });
                _context.prev = 8;
                res = null;

                if (!(status === 'draft')) {
                  _context.next = 17;
                  break;
                }

                _context.next = 13;
                return _axios.default.post("/event/".concat(eventId), data);

              case 13:
                res = _context.sent;
                isSaveErrorResponse = this.handlePublishErrorResponse(res);

                if (!isSaveErrorResponse) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                _context.next = 19;
                return _axios.default.post(endpoint, data);

              case 19:
                res = _context.sent;
                isErrorResponse = this.handlePublishErrorResponse(res);

                if (!isErrorResponse) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("return");

              case 23:
                this.handlePublishResponse(res);
                _context.next = 31;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](8);
                this.setState({
                  isLoading: false
                });
                responseError = _context.t0.response || null;
                this.handlePostErrors(responseError);

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 26]]);
      }));

      function onPublish() {
        return _onPublish.apply(this, arguments);
      }

      return onPublish;
    }()
  }, {
    key: "onSaveChanges",
    value: function () {
      var _onSaveChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var status, hasErrors, eventId, res, isErrorResponse, responseError;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                status = this.state.status;
                hasErrors = status === 'draft' ? this.hasDraftErrors() : this.hasErrors();

                if (!hasErrors) {
                  _context2.next = 5;
                  break;
                }

                this.showValidationError();
                return _context2.abrupt("return");

              case 5:
                eventId = this.state.eventId;
                this.setState({
                  isLoading: true
                });
                _axios.default.defaults.headers.common = {
                  'X-CSRF-TOKEN': this.csrfToken
                };
                _context2.prev = 8;
                _context2.next = 11;
                return _axios.default.post("/event/".concat(eventId), (0, _common2.getPublishData)(this.state));

              case 11:
                res = _context2.sent;
                isErrorResponse = this.handlePublishErrorResponse(res);

                if (!isErrorResponse) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                this.handleSaveChangesResponse();
                _context2.next = 23;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](8);
                this.setState({
                  isLoading: false
                });
                responseError = _context2.t0.response || null;
                this.handlePostErrors(responseError);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 18]]);
      }));

      function onSaveChanges() {
        return _onSaveChanges.apply(this, arguments);
      }

      return onSaveChanges;
    }()
  }, {
    key: "onSaveAsDraft",
    value: function () {
      var _onSaveAsDraft = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var data, res, isErrorResponse, responseError;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.hasDraftErrors()) {
                  _context3.next = 3;
                  break;
                }

                this.showValidationError();
                return _context3.abrupt("return");

              case 3:
                this.setState({
                  isLoading: true
                });
                _axios.default.defaults.headers.common = {
                  'X-CSRF-TOKEN': this.csrfToken
                };
                data = _objectSpread(_objectSpread({}, (0, _common2.getPublishData)(this.state)), {}, {
                  status: 'draft'
                });
                _context3.prev = 6;
                _context3.next = 9;
                return _axios.default.post('/content/publish/event', data);

              case 9:
                res = _context3.sent;
                isErrorResponse = this.handlePublishErrorResponse(res);

                if (!isErrorResponse) {
                  _context3.next = 13;
                  break;
                }

                return _context3.abrupt("return");

              case 13:
                this.handleSaveAsDraftResponse(res);
                _context3.next = 21;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](6);
                this.setState({
                  isLoading: false
                });
                responseError = _context3.t0.response || null;
                this.handlePostErrors(responseError);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 16]]);
      }));

      function onSaveAsDraft() {
        return _onSaveAsDraft.apply(this, arguments);
      }

      return onSaveAsDraft;
    }()
  }, {
    key: "onDuplicate",
    value: function () {
      var _onDuplicate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var res, isErrorResponse, responseError;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.hasDraftErrors()) {
                  _context4.next = 3;
                  break;
                }

                this.showValidationError();
                return _context4.abrupt("return");

              case 3:
                this.setState({
                  isLoading: true
                });
                _axios.default.defaults.headers.common = {
                  'X-CSRF-TOKEN': this.csrfToken
                };
                _context4.prev = 5;
                _context4.next = 8;
                return _axios.default.post('/content/publish/event', (0, _common2.getDuplicateData)(_objectSpread(_objectSpread({}, this.state), {}, {
                  title: "".concat(this.state.title, " (copy)"),
                  status: 'draft'
                })));

              case 8:
                res = _context4.sent;
                isErrorResponse = this.handlePublishErrorResponse(res);

                if (!isErrorResponse) {
                  _context4.next = 12;
                  break;
                }

                return _context4.abrupt("return");

              case 12:
                this.handleDuplicateResponse(res);
                _context4.next = 20;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](5);
                this.setState({
                  isLoading: false
                });
                responseError = _context4.t0.response || null;
                this.handlePostErrors(responseError);

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 15]]);
      }));

      function onDuplicate() {
        return _onDuplicate.apply(this, arguments);
      }

      return onDuplicate;
    }()
  }, {
    key: "onDelete",
    value: function () {
      var _onDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var eventId, responseError;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                eventId = this.state.eventId;
                this.setState({
                  isLoading: true
                });
                _context5.prev = 2;
                _context5.next = 5;
                return _axios.default.delete("/event/".concat(eventId), {
                  data: {
                    csrfToken: this.csrfToken
                  },
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  }
                });

              case 5:
                window.location.assign((0, _absoluteUrlRuntime.resolveUrl)('/event/overview'));
                _context5.next = 13;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
                this.setState({
                  isLoading: false
                });
                responseError = _context5.t0.response || null;
                this.handlePostErrors(responseError);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 8]]);
      }));

      function onDelete() {
        return _onDelete.apply(this, arguments);
      }

      return onDelete;
    }()
  }, {
    key: "handlePublishErrorResponse",
    value: function handlePublishErrorResponse(res) {
      if (res.status >= 400) {
        this.setState({
          isLoading: false,
          backendResponse: {
            messageType: 'error',
            messageText: 'Something went wrong, please try again later'
          }
        });
        return true;
      }

      return false;
    }
  }, {
    key: "handlePublishResponse",
    value: function handlePublishResponse(res) {
      var _this$state9 = this.state,
          status = _this$state9.status,
          title = _this$state9.title,
          type = _this$state9.type,
          eventId = _this$state9.eventId;
      this.setState({
        hasUnsavedChanges: false,
        isLoading: false,
        eventId: status === 'new' ? res.data.id : eventId,
        status: 'published',
        backendResponse: {
          messageType: 'success',
          messageText: 'This event has been published successfully!'
        }
      });

      if (status === 'new') {
        window.history.pushState(null, '', "/event/".concat(res.data.id));
        (0, _common2.trackEventCreated)(res, title, type);
      }
    }
  }, {
    key: "handleSaveChangesResponse",
    value: function handleSaveChangesResponse() {
      this.setState({
        hasUnsavedChanges: false,
        isLoading: false,
        backendResponse: {
          messageType: 'success',
          messageText: 'Your event has been saved'
        }
      });
    }
  }, {
    key: "handleSaveAsDraftResponse",
    value: function handleSaveAsDraftResponse(res) {
      this.setState({
        hasUnsavedChanges: false,
        isLoading: false,
        eventId: res.data.id,
        status: 'draft',
        backendResponse: {
          messageType: 'success',
          messageText: 'Your event has been saved'
        }
      });
      window.history.pushState(null, '', "/event/".concat(res.data.id));
      var _this$state10 = this.state,
          title = _this$state10.title,
          type = _this$state10.type;
      (0, _common2.trackEventCreated)(res, title, type);
    }
  }, {
    key: "handleDuplicateResponse",
    value: function handleDuplicateResponse(res) {
      var _this$state11 = this.state,
          title = _this$state11.title,
          type = _this$state11.type,
          startDateFP = _this$state11.startDateFP,
          endDateFP = _this$state11.endDateFP;
      var timezoneList = this.props.timezoneList;
      this.setState({
        hasUnsavedChanges: false,
        isLoading: false,
        eventId: res.data.id,
        title: "".concat(title, " (copy)"),
        status: 'draft',
        backendResponse: {
          messageType: 'success',
          messageText: 'Your event has been successfully duplicated'
        },
        startDate: '',
        endDate: '',
        startTime: {},
        endTime: {},
        externalRegistrationUrl: '',
        externalRegistrationUrlLabel: '',
        enableRsvpGroupPicker: null,
        timezone: (0, _common2.getUserTimezone)(timezoneList)
      });
      var currentDate = new Date();
      startDateFP === null || startDateFP === void 0 ? void 0 : startDateFP.clear();
      startDateFP === null || startDateFP === void 0 ? void 0 : startDateFP.jumpToDate(currentDate, true);
      endDateFP === null || endDateFP === void 0 ? void 0 : endDateFP.clear();
      endDateFP === null || endDateFP === void 0 ? void 0 : endDateFP.jumpToDate(currentDate, true);
      window.history.pushState(null, '', "/event/".concat(res.data.id));
      (0, _common2.trackEventCreated)(res, title, type);
    }
  }, {
    key: "redirectToOverview",
    value: function redirectToOverview(url) {
      var _this4 = this;

      this.setState({
        hasUnsavedChanges: false
      }, function () {
        window.location.assign((0, _absoluteUrlRuntime.resolveUrl)("".concat(url, "?deleted&title=").concat(_this4.state.title)));
      });
    }
  }, {
    key: "setFeaturedTopics",
    value: function setFeaturedTopics(value) {
      this.setState({
        featuredTopics: value,
        hasUnsavedChanges: true
      });
    }
  }, {
    key: "getTimezone",
    value: function getTimezone(timezone) {
      var find = this.props.timezoneList.find(function (tz) {
        return tz.value === timezone;
      });

      if (!find) {
        this.setState(function (prevState) {
          return {
            errors: prevState.errors.addError('timezone', 'Failed to pick timezone')
          };
        });
        return {
          title: '',
          value: ''
        };
      }

      return find;
    }
  }, {
    key: "onVisibilityChange",
    value: function onVisibilityChange(option) {
      this.setState({
        enableGroupsPicker: option === 'Group event',
        group: undefined,
        userGroupId: undefined,
        hasUnsavedChanges: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this,
          _featuredImageDimensi,
          _featuredImageDimensi2;

      var _this$props = this.props,
          timezoneList = _this$props.timezoneList,
          eventTypes = _this$props.eventTypes,
          groups = _this$props.groups;
      var _this$state12 = this.state,
          eventId = _this$state12.eventId,
          type = _this$state12.type,
          title = _this$state12.title,
          location = _this$state12.location,
          url = _this$state12.url,
          urlLabel = _this$state12.urlLabel,
          featuredImage = _this$state12.featuredImage,
          description = _this$state12.description,
          isLoading = _this$state12.isLoading,
          hasUnsavedChanges = _this$state12.hasUnsavedChanges,
          errors = _this$state12.errors,
          backendResponse = _this$state12.backendResponse,
          startDate = _this$state12.startDate,
          startTime = _this$state12.startTime,
          endDate = _this$state12.endDate,
          endTime = _this$state12.endTime,
          timezone = _this$state12.timezone,
          confirmationMessage = _this$state12.confirmationMessage,
          enableGroupsPicker = _this$state12.enableGroupsPicker,
          enableRsvpGroupPicker = _this$state12.enableRsvpGroupPicker,
          group = _this$state12.group,
          externalRegistrationUrl = _this$state12.externalRegistrationUrl,
          externalRegistrationUrlLabel = _this$state12.externalRegistrationUrlLabel,
          isEventPassed = _this$state12.isEventPassed,
          setEndDateManually = _this$state12.setEndDateManually,
          status = _this$state12.status,
          isVisibilityPanelClicked = _this$state12.isVisibilityPanelClicked,
          featuredImageDimensions = _this$state12.featuredImageDimensions;
      var staticEventTypeOption = type ? [{
        title: 'Choose an event type',
        onClick: function onClick() {
          return _this5.setState({
            type: '',
            hasUnsavedChanges: true
          });
        }
      }] : [];

      var isPastEvent = _EventDateFormatter.default.isPastEvent(new Date(endDate).getTime() / 1000);

      var startTimeDateObj = startDate && startTime !== null && startTime !== void 0 && startTime.hours ? new Date(getFullDateString(startDate, startTime)) : null;
      var endTimeDateObj = endDate && endTime !== null && endTime !== void 0 && endTime.hours ? new Date(getFullDateString(endDate, endTime)) : null;

      var communityRsvpOption = function communityRsvpOption() {
        return (0, _preact.h)("div", null, enableRsvpGroupPicker === 'community' ? (0, _preact.h)("div", null, (0, _preact.h)("div", {
          className: "editor-confirmation-message"
        }, (0, _preact.h)("div", {
          className: "form-group"
        }, (0, _preact.h)("label", null, "Confirmation message"), " ", (0, _preact.h)("span", null, "(optional)"), (0, _preact.h)("div", {
          className: "confirmation-message-information"
        }, "This message will be shown when users RSVP to this event"), (0, _preact.h)(_editor.default, {
          classes: ['qa-event-confirmation-message'],
          isControl: true,
          canHavePoll: false,
          data: confirmationMessage,
          onChange: function onChange(message) {
            if (message === confirmationMessage) return;

            _this5.setState({
              confirmationMessage: message,
              hasUnsavedChanges: true
            });
          }
        })))) : '');
      };

      var externalRsvpOption = function externalRsvpOption() {
        return (0, _preact.h)("div", null, enableRsvpGroupPicker === 'external' ? (0, _preact.h)("div", {
          className: "location-external-data-inputs"
        }, (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
          title: "Registration button text ",
          value: externalRegistrationUrlLabel !== null && externalRegistrationUrlLabel !== void 0 ? externalRegistrationUrlLabel : undefined,
          qaClasses: "qa-external-rsvp-url-label",
          placeholder: "e.g. Register now",
          error: errors.getError('externalRegistrationUrlLabel'),
          formGroupClasses: "location-data-input",
          onChange: function onChange(e) {
            return _this5.setState({
              externalRegistrationUrlLabel: e.target.value,
              hasUnsavedChanges: true,
              errors: errors.clearError('externalRegistrationUrlLabel')
            });
          },
          disabled: status === 'published' && isPastEvent
        })), (0, _preact.h)("div", {
          className: "location-data-url"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Registration URL",
          value: externalRegistrationUrl,
          qaClasses: "qa-external-rsvp-url",
          placeholder: "https://",
          error: errors.getError('externalRegistrationUrl'),
          formGroupClasses: "location-data-input",
          onChange: function onChange(e) {
            return _this5.setState({
              externalRegistrationUrl: e.target.value,
              hasUnsavedChanges: true,
              errors: errors.clearError('externalRegistrationUrl')
            });
          },
          disabled: status === 'published' && isPastEvent
        }))) : '');
      };

      var detailsPanel = {
        id: 'detailsPanel',
        customClass: 'qa-details-panel',
        title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
          customClass: "panel-header-container",
          iconCustomClass: "icon-panel-header",
          icon: "edit",
          title: "Details",
          isDone: !!this.state.title && this.state.title.length >= _validation.MIN_TITLE_LENGTH && !errors.getError('title')
        }),
        error: !!errors.getError('title'),
        body: (0, _preact.h)("div", {
          className: "row"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Event name",
          value: title,
          qaClasses: "qa-event-title",
          onChange: function onChange(e) {
            return _this5.setState({
              title: e.target.value,
              hasUnsavedChanges: true,
              errors: errors.clearError('title')
            });
          },
          formGroupClasses: "event-title",
          error: errors.getError('title')
        }), (0, _preact.h)("div", {
          className: "event-type"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Event type",
          optional: true,
          customInput: (0, _preact.h)(_DropdownControl.default, {
            closeOnDropdownClick: true,
            align: "adjust",
            triggerClass: "type-dropdown qa-event-type",
            items: staticEventTypeOption.concat(eventTypes.map(function (type) {
              return {
                title: (0, _common2.getUnescapedName)(type.name),
                onClick: function onClick() {
                  return _this5.setState({
                    type: type.name,
                    hasUnsavedChanges: true
                  });
                }
              };
            })),
            trigger: (0, _preact.h)(_Button.default, {
              className: type ? 'selected' : 'default',
              title: type || 'Choose an event type',
              icon: "chevronDown",
              "data-track-type": "click",
              "data-element-name": "Choose an event type button"
            })
          })
        }), (0, _preact.h)("div", {
          className: "link-manage-event-type"
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/eventTypes"),
          target: "_blank",
          "data-track-type": "click",
          "data-element-name": "Manage event types link"
        }, "Manage event types"))), (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
          title: "Location",
          value: location,
          qaClasses: "qa-event-location",
          meta: (0, _preact.h)("div", {
            className: "location-meta"
          }, "If you leave the location blank, your event will display as an ", (0, _preact.h)("b", null, "Online Event"), ". Otherwise, it will display as an ", (0, _preact.h)("b", null, "In-person Event"), "."),
          formGroupClasses: "location-input",
          onChange: function onChange(e) {
            return _this5.setState({
              location: e.target.value,
              hasUnsavedChanges: true
            });
          }
        })))
      };
      var startDatePickerProps = {
        format: 'M d Y',
        allowInput: false,
        allowPastDates: true,
        error: errors.getError('startDate') !== '',
        classes: ['qa-event-start-date'],
        onChange: this.onStartDateChange,
        value: startDate ? _EventDateFormatter.default.clearDateTimezone(startDate) : '',
        onSetFPInstance: function onSetFPInstance(fp) {
          return _this5.setState({
            startDateFP: fp
          });
        }
      };
      var endDatePickerProps = {
        format: 'M d Y',
        allowInput: false,
        allowPastDates: true,
        error: errors.getError('endDate') !== '',
        onChange: this.onEndDateChange,
        initialValue: endDate,
        setManuallyFromProps: setEndDateManually,
        classes: ['qa-event-end-date'],
        minDate: startDate,
        value: endDate ? _EventDateFormatter.default.clearDateTimezone(endDate) : '',
        onSetFPInstance: function onSetFPInstance(fp) {
          return _this5.setState({
            endDateFP: fp
          });
        }
      };
      var timePanel = {
        id: 'timePanel',
        customClass: 'qa-time-panel',
        title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
          customClass: "panel-header-container",
          iconCustomClass: "icon-panel-header",
          icon: "clock",
          title: "Time",
          isDone: this.hasTiming()
        }),
        disabled: status === 'published' && isEventPassed,
        error: !!errors.getError('timezone') || !!errors.getError('startDate') || !!errors.getError('startTime') || !!errors.getError('endDate') || !!errors.getError('endTime'),
        body: (0, _preact.h)("div", null, (0, _preact.h)("div", {
          className: "row"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Timezone",
          error: errors.getError('timezone'),
          customInput: (0, _preact.h)(_TimezoneSelector.default, {
            triggerClassName: "qa-event-timezone",
            error: errors.getError('timezone') !== '',
            timezones: timezoneList,
            selected: timezone && timezoneList.find(function (tz) {
              return tz.value === timezone.value;
            }),
            onChange: function onChange(timezone) {
              return _this5.setState({
                timezone: _this5.getTimezone(timezone),
                hasUnsavedChanges: true,
                errors: errors.clearError('timezone')
              });
            }
          })
        })), (0, _preact.h)("div", {
          className: "row date-wrapper"
        }, (0, _preact.h)("div", {
          className: "date-picker-wrapper"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Start date",
          error: errors.getError('startDate'),
          customInput: (0, _preact.h)(_datePicker.default, startDatePickerProps)
        })), (0, _preact.h)("div", {
          className: "time-picker-wrapper"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Start time",
          id: "start-time",
          newStyle: true,
          error: errors.getError('startTime'),
          customInput: (0, _preact.h)(_DropdownBox.default, {
            disabled: false,
            error: errors.getError('startTime') !== '',
            hasChevron: true,
            className: "qa-event-start-time",
            title: (0, _preact.h)("span", {
              className: "dropdown-title"
            }, startDate ? (0, _preact.h)("span", {
              className: "dropdown-value"
            }, getTimeString(startTime)) : (0, _preact.h)("span", {
              className: "dropdown-placeholder"
            }, "Select a time"))
          }, startTimeDateObj ? (0, _preact.h)(_TimepickerV.default, {
            disableInput: true,
            value: startTimeDateObj,
            onClose: this.onCloseStartTimepicker
          }) : null)
        }))), (0, _preact.h)("div", {
          className: (0, _classnames.default)(['row date-wrapper', !startDate && 'disabled'])
        }, (0, _preact.h)("div", {
          className: "date-picker-wrapper"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "End date",
          error: errors.getError('endDate'),
          customInput: (0, _preact.h)(_datePicker.default, endDatePickerProps)
        })), (0, _preact.h)("div", {
          className: "time-picker-wrapper"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "End time",
          id: "end-time",
          newStyle: true,
          error: errors.getError('endTime'),
          customInput: (0, _preact.h)(_DropdownBox.default, {
            disabled: false,
            error: errors.getError('endTime') !== '',
            hasChevron: true,
            className: "qa-event-end-time",
            title: (0, _preact.h)("span", {
              className: "dropdown-title"
            }, endDate ? (0, _preact.h)("span", {
              className: "dropdown-value"
            }, getTimeString(endTime)) : (0, _preact.h)("span", {
              className: "dropdown-placeholder"
            }, "Select a time"))
          }, endTimeDateObj ? (0, _preact.h)(_TimepickerV.default, {
            disableInput: true,
            value: endTimeDateObj,
            onClose: this.onCloseEndTimepicker
          }) : null)
        }))))
      };
      var locationPanel = {
        id: 'locationPanel',
        customClass: 'qa-registration-panel',
        title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
          customClass: "panel-header-container",
          iconCustomClass: "icon-panel-header",
          icon: "send",
          title: "Registration",
          isDone: status === 'published' || enableRsvpGroupPicker === 'community' || enableRsvpGroupPicker === 'external' && !!externalRegistrationUrl && !!externalRegistrationUrlLabel
        }),
        error: !!errors.getError('registration') || !!errors.getError('externalRegistrationUrl') || !!errors.getError('externalRegistrationUrlLabel'),
        body: (0, _preact.h)("div", {
          className: "location-panel"
        }, (0, _preact.h)("div", {
          className: "row"
        }, (0, _preact.h)("div", {
          className: "form-group"
        }, (0, _preact.h)("label", null, "Registration"), (0, _preact.h)(_Message.Message, {
          text: "This is a permanent setting, you can't change it once the event is published.",
          variant: "info"
        })), (0, _preact.h)("div", {
          className: (0, _classnames.default)(['radio-imitaion-buttons', status === 'published' && eventId && 'is-saved'])
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('radio-imitaion-button', 'qa-community-event', {
            selected: enableRsvpGroupPicker === 'community',
            disabled: status === 'published',
            error: errors.getError('registration')
          }),
          onClick: function onClick() {
            return status !== 'published' && _this5.setState({
              enableRsvpGroupPicker: 'community',
              hasUnsavedChanges: true,
              externalRegistrationUrl: '',
              externalRegistrationUrlLabel: '',
              errors: errors.clearError('registration').clearError('externalRegistrationUrl').clearError('externalRegistrationUrlLabel')
            });
          }
        }, (0, _preact.h)("div", {
          className: "icon"
        }, (0, _preact.h)(_assets.default, {
          icon: "oneOffEmail",
          width: 35,
          height: 30
        })), (0, _preact.h)("div", {
          className: "radio-imitaion-label"
        }, "Community Event"), (0, _preact.h)("div", {
          className: "description"
        }, "Registered users can register for the event, which will show their registration on the event page and in the CSV export.")), (0, _preact.h)("div", {
          className: (0, _classnames.default)('radio-imitaion-button', 'qa-external-event', {
            selected: enableRsvpGroupPicker === 'external',
            disabled: status === 'published',
            error: errors.getError('registration')
          }),
          onClick: function onClick() {
            return status !== 'published' && _this5.setState({
              enableRsvpGroupPicker: 'external',
              hasUnsavedChanges: true,
              errors: errors.clearError('registration')
            });
          }
        }, (0, _preact.h)("div", {
          className: "icon"
        }, (0, _preact.h)(_assets.default, {
          icon: "automatedEmail",
          width: 35,
          height: 30
        })), (0, _preact.h)("div", {
          className: "radio-imitaion-label"
        }, "External Event"), (0, _preact.h)("div", {
          className: "description"
        }, "Users will register for the event externally, and the primary button will send your attendees to the external registration page."))), errors.getError('registration') ? (0, _preact.h)("div", {
          className: "registration-error"
        }, errors.getError('registration')) : null), (0, _preact.h)("div", {
          className: "row event-group-wrapper"
        }, communityRsvpOption(), externalRsvpOption()))
      };
      var descriptionPanel = {
        id: 'descriptionPanel',
        customClass: 'qa-description-panel',
        title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
          customClass: "panel-header-container",
          iconCustomClass: "icon-panel-header",
          icon: "description",
          title: "Description",
          isDone: this.hasDescription() && !errors.getError('description')
        }),
        error: !!errors.getError('description') || !!errors.getError('urlLabel') || !!errors.getError('url'),
        body: (0, _preact.h)("div", {
          className: "description-panel"
        }, (0, _preact.h)("div", {
          className: "row"
        }, (0, _preact.h)("div", {
          className: "col-xs-12"
        }, (0, _preact.h)(_Attachments.default, {
          label: "Event image",
          className: "event-creator__sidebar-featured-image",
          meta: (0, _preact.h)("div", {
            className: "event-meta"
          }, "Maximum file size: 5M. Allowed image types: .jpg, .jpeg, .png, .gif. We recommend a minimum of 1440*640px"),
          isAttachmentSelected: featuredImage && featuredImage !== '',
          imageSrc: featuredImage !== null && featuredImage !== void 0 ? featuredImage : null,
          width: (_featuredImageDimensi = featuredImageDimensions === null || featuredImageDimensions === void 0 ? void 0 : featuredImageDimensions.width) !== null && _featuredImageDimensi !== void 0 ? _featuredImageDimensi : 630,
          height: (_featuredImageDimensi2 = featuredImageDimensions === null || featuredImageDimensions === void 0 ? void 0 : featuredImageDimensions.height) !== null && _featuredImageDimensi2 !== void 0 ? _featuredImageDimensi2 : 280,
          onUpdate: function onUpdate(data) {
            var _data$source;

            _this5.setState({
              featuredImage: data ? data.source_thumb : undefined,
              hasUnsavedChanges: true
            });

            _this5.setImageDimensions((_data$source = data === null || data === void 0 ? void 0 : data.source) !== null && _data$source !== void 0 ? _data$source : '');
          }
        }))), (0, _preact.h)("div", {
          className: "row"
        }, (0, _preact.h)("div", {
          className: "editor"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Event description",
          meta: (0, _preact.h)("div", {
            className: "event-meta"
          }, "Provide more information about your event so guests know what to expect."),
          error: errors.getError('description'),
          customInput: (0, _preact.h)(_editor.default, {
            classes: ['qa-event-description'],
            error: errors.getError('description') !== '',
            isControl: true,
            data: description,
            onChange: function onChange(content) {
              if (content === description) return;

              _this5.setState({
                description: content,
                hasUnsavedChanges: true,
                errors: errors.clearError('description')
              });
            }
          })
        }))), (0, _preact.h)("div", {
          className: "row location-data-inputs"
        }, (0, _preact.h)("div", null, (0, _preact.h)(_InputGroup.default, {
          title: "Link text",
          value: urlLabel,
          qaClasses: "qa-event-url-label",
          optional: true,
          formGroupClasses: "location-data-input",
          onChange: function onChange(e) {
            return _this5.setState({
              urlLabel: e.target.value,
              hasUnsavedChanges: true,
              errors: errors.clearError('urlLabel')
            });
          },
          error: errors.getError('urlLabel')
        })), (0, _preact.h)("div", {
          className: "location-data-url"
        }, (0, _preact.h)(_InputGroup.default, {
          title: "Link URL",
          value: url,
          qaClasses: "qa-event-url",
          optional: true,
          formGroupClasses: "location-data-input",
          onChange: function onChange(e) {
            return _this5.setState({
              url: e.target.value,
              hasUnsavedChanges: true,
              errors: errors.clearError('url')
            });
          },
          error: errors.getError('url')
        }))))
      };
      var visibilityPanel = {
        id: 'visibilityPanel',
        title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
          customClass: "panel-header-container",
          iconCustomClass: "icon-panel-header",
          icon: "eye",
          title: "Visibility",
          isDone: !!isVisibilityPanelClicked || !!eventId
        }),
        onClickPanel: function onClickPanel() {
          if (!isVisibilityPanelClicked) {
            _this5.setState({
              isVisibilityPanelClicked: true
            });
          }
        },
        body: (0, _preact.h)("div", {
          className: "row event-group-wrapper"
        }, (0, _preact.h)(_Message.Message, {
          text: "This is a permanent setting, you can't change it once the event is published.",
          variant: "info"
        }), (0, _preact.h)("div", {
          className: "col-xs-12 visibility-radio"
        }, (0, _preact.h)(_RadioInputGroup.default, {
          title: "Publish as",
          options: ['Public event', 'Group event'],
          valueDescriptions: ['Discoverable by anyone in the community.', 'Group event will inherit group content visibility, e.g. private and hidden group events are only visible to members.'],
          onChange: function onChange(option) {
            return _this5.onVisibilityChange(option);
          },
          value: enableGroupsPicker || group ? 'Group event' : 'Public event',
          disabled: status === 'published'
        }), groups && (0, _preact.h)(_DropdownControl.default, {
          closeOnDropdownClick: true,
          align: "adjust",
          triggerClass: "group-dropdown qa-event-group",
          disabled: !enableGroupsPicker || status === 'published',
          items: groups.map(function (group) {
            return {
              title: group.title,
              onClick: function onClick() {
                return _this5.setState({
                  group: group,
                  hasUnsavedChanges: true
                });
              }
            };
          }),
          trigger: (0, _preact.h)(_Button.default, {
            disabled: !enableGroupsPicker,
            className: group ? 'selected' : 'default',
            title: group ? group.title : 'Choose group',
            icon: "chevronDown",
            "data-track-type": "click",
            "data-element-name": "choose group button"
          })
        })))
      };
      var featuredPanel = {
        id: 'featuredPanel',
        heading: 'Optional settings',
        title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
          customClass: "panel-header-container",
          iconCustomClass: "icon-panel-header",
          icon: "topics",
          title: "Featured topics"
        }),
        body: (0, _preact.h)("div", {
          className: "row"
        }, (0, _preact.h)("div", {
          className: "featured-topics"
        }, (0, _preact.h)(_FeaturedTopicsManager.default, {
          searchPlaceholder: "Add a topic by pasting topic URL or searching",
          onUpdate: function onUpdate(_, value) {
            return _this5.setFeaturedTopics(value);
          },
          featuredTopics: this.state.featuredTopics,
          isSortable: false,
          includeContentTypes: ['discussion', 'question', 'article', 'ideation'].concat((0, _toConsumableArray2.default)(_common.common.isModuleActive('eventFeaturedProductUpdates') ? ['productUpdate'] : [])),
          searchWithContentTypes: true,
          description: "Engage your attendees before and after your event by featuring relevant topics on the event page.",
          withoutRedirect: true
        })))
      };
      var panels = groups && this.isPrivateGroupEnabled ? [detailsPanel, timePanel, locationPanel, descriptionPanel, visibilityPanel, featuredPanel] : [detailsPanel, timePanel, locationPanel, descriptionPanel, featuredPanel];
      var expandedPanelByDefault = ['detailsPanel', 'timePanel', 'locationPanel', 'descriptionPanel', 'visibilityPanel'];
      return (0, _preact.h)("div", {
        className: "qa-event-form",
        "data-bounded-context": "Event",
        "data-entity": "create-event-new"
      }, (0, _preact.h)(_Header.default, {
        hasUnsavedChanges: hasUnsavedChanges,
        title: title,
        status: status,
        error: errors.getError('title'),
        csvDownloadUrl: "/event/csv?eventId=".concat(eventId),
        csvDownloadText: "Download attendee list",
        onTitleChanged: function onTitleChanged(title) {
          return _this5.setState({
            title: title,
            hasUnsavedChanges: true,
            errors: errors.clearError('title')
          });
        },
        onPublish: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return _this5.onPublish();

                case 2:
                  return _context6.abrupt("return", _context6.sent);

                case 3:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        })),
        onSaveChanges: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
          return _regenerator.default.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return _this5.onSaveChanges();

                case 2:
                  return _context7.abrupt("return", _context7.sent);

                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        })),
        onSaveAsDraft: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return _this5.onSaveAsDraft();

                case 2:
                  return _context8.abrupt("return", _context8.sent);

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        })),
        onDuplicate: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
          return _regenerator.default.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _this5.onDuplicate();

                case 2:
                  return _context9.abrupt("return", _context9.sent);

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        })),
        onDelete: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
          return _regenerator.default.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return _this5.onDelete();

                case 2:
                  return _context10.abrupt("return", _context10.sent);

                case 3:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        })),
        isEventPassed: isEventPassed,
        eventId: eventId
      }), isLoading && (0, _preact.h)(_Loader.default, null), (0, _preact.h)("div", {
        className: "control-body"
      }, backendResponse.messageType !== null && (0, _preact.h)(_message.default, {
        isControl: true,
        variant: backendResponse.messageType,
        message: backendResponse.messageText,
        onDismiss: function onDismiss() {
          return _this5.setState({
            backendResponse: {
              messageType: null,
              messageText: ''
            }
          });
        },
        timer: 3000
      }), (0, _preact.h)(_AccordionPanel.default, {
        defaultActivePanelIndex: 0,
        expandedPanels: panels.reduce(function (res, panel) {
          return _objectSpread(_objectSpread({}, res), {}, (0, _defineProperty2.default)({}, panel.id, expandedPanelByDefault.includes(panel.id)));
        }, {}),
        panels: panels
      })));
    }
  }]);
  return EventCreator;
}(_preact.Component);

var _default = EventCreator;
exports.default = _default;